import { Check } from 'lucide-react';
import Button from '../../../../components/primitives/Button.jsx';
import Card from '../../../../components/primitives/Card.jsx';
import ExecutionStatus from '../../../../components/surfaces/ExecutionStatus.jsx';

const STEPS = [
  { id: 'read', state: 'done', title: 'Read overdue invoices', detail: '7 invoices over 30 days in QuickBooks' },
  { id: 'draft', state: 'done', title: 'Drafted a reminder for each customer', detail: '7 Gmail drafts, nothing sent yet' },
  { id: 'approve', state: 'waiting', title: 'Your approval to send', detail: 'Uses send access on billing@northwind.co' },
  { id: 'log', state: 'queued', title: 'Log the follow-up on each invoice', detail: 'Adds a private note in QuickBooks' }
];

/** How execution states combine in a run: what Pieve did, what it needs, what happens next. */
const RunExampleCard = () => {
  return (
    <Card featured title="Overdue invoice follow-up" description="Runs every Monday at 9:00. Started 4 minutes ago." actions={<ExecutionStatus state="waiting" />}>
      <ol className="gallery-run-steps">
        {STEPS.map((step) => (
          <li key={step.id} className="gallery-run-step" data-state={step.state}>
            <span className="gallery-run-step__node" aria-hidden="true" />
            <div className="gallery-run-step__text">
              <span className="gallery-run-step__title">{step.title}</span>
              <span className="gallery-run-step__detail">{step.detail}</span>
            </div>
            <ExecutionStatus state={step.state} size="sm" />
          </li>
        ))}
      </ol>
      <div className="gallery-run-actions">
        <Button variant="ghost">Review drafts</Button>
        <Button variant="primary" iconStart={Check}>
          Approve and send 7 emails
        </Button>
      </div>
    </Card>
  );
};

export default RunExampleCard;
